import shortly from 'vuex-shortly'
import {
  CLIENTS, ACCOUNT, ACCOUNT_CONFIG, ACCOUNT_CONFIG_UPDATE, ACCOUNT_VINDI, ACCOUNT_UPDATE,
  ACCOUNT_CREATE, ACCOUNT_PATCH, ACCOUNT_DELETE, ACCOUNT_CLEAR, NOTIFICATIONS_INCLUDE, CREATE_WALLET_ORDER, CREATE_WALLET_EXIT_ORDER
} from '@store/types'
import axios from 'axios'
import graphQL from '@graphQL'
import AccountQuery from '@graphQL/queries/Account'
import { toDeepFormData } from '@/helpers/cast'
import { cleanObj } from '@/helpers/cleanObj'
import router from '@/router'

const state = {
  account: {},
  vindi: null
}

const getters = {
  [ACCOUNT]: 'account',

  [ACCOUNT_VINDI]: ({ vindi }) => {
    return (((vindi || {}).data || {}).data || {})
  },

  [ACCOUNT_CONFIG]: ({ account: { implantation, logo, config } }) => ({
    implantation,
    logo,
    ...config
  })
}

const mutations = {
  [ACCOUNT]: (state, payload) => {
    state.account = { ...payload }
  },

  [ACCOUNT_UPDATE]: (state, payload) => {
    state.account = { ...state.account, ...payload }
  },

  [ACCOUNT_VINDI]: (state, payload) => {
    state.vindi = { ...payload }
  }
}

const actions = {
  [ACCOUNT]: async ({ commit, dispatch }, params) => {
    const response = await graphQL(AccountQuery, params)
    if (response.data && response.data.errors && response.data.errors.length > 0) {
      await dispatch(NOTIFICATIONS_INCLUDE, Error('Conta não encontrada'))
      router.push({ name: 'Parceiros' })
      return
    }
    let { company: account } = response.data ? response.data.data : {}

    const toggles = ['has_exclusive_experience', 'has_geolocation_access', 'withdraw_award', 'withdraw_engagement']
    toggles.forEach(key => {
      if (!account.config[key]) account.config[key] = false
    })

    const negativeEmailArray = account.config.has_exclusive_experience_emails
    if (negativeEmailArray !== null && negativeEmailArray.length > 0) {
      account.config.has_exclusive_experience_email_string = negativeEmailArray.toString()
    } else {
      account.config.has_exclusive_experience_email_string = ''
    }
    commit(ACCOUNT, account || {})
    return response
  },

  [ACCOUNT_UPDATE]: ({ commit }, payload) => {
    commit(ACCOUNT_UPDATE, payload)
  },

  [ACCOUNT_CREATE]: async ({ dispatch }, payload) => {
    try {
      payload.contract = null

      const response = await axios.post('/company', cleanObj(payload))

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Conta criada com sucesso!'
      })

      dispatch(ACCOUNT, {
        id: response.data.data.id,
        includeEdit: true,
        includeDetails: false
      })

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível criar a conta'))
    }
  },

  [ACCOUNT_PATCH]: async ({ dispatch, commit }, { payload, accountId }) => {
    try {
      const negativeEmails = payload.config.has_exclusive_experience_email_string
      if (negativeEmails && negativeEmails.length > 0) {
        const negativeEmailUnfilteredArray = negativeEmails.replace(/\s/g, '').split(',')
        const negativeEmailFilteredArray = negativeEmailUnfilteredArray.filter((str) => {
          return /\S/.test(str)
        })
        payload.config.has_exclusive_experience_emails = negativeEmailFilteredArray
      }

      payload.contract = null
      commit(ACCOUNT_UPDATE, payload)

      const logoutUrl = payload.config.logout_url
      const clean = cleanObj(payload)

      clean.config.logout_url = logoutUrl
      if (!clean.config.marketplace_client_url) {
        clean.config.marketplace_client_url = ''
      }

      if (!clean.config.block_banks_at_cashback) {
        delete clean.config.allowed_banks
      }
      if (clean.config.logo) {
        delete clean.config.logo
      }
      // if (clean.config.has_initial_page && clean.config.redirect_logout) {
      //  clean.config.redirect_logout = false
      // }
      const response = await axios.patch(`/company/${accountId}`, { ...clean })

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Conta alterada com sucesso!'
      })

      dispatch(ACCOUNT, {
        id: accountId,
        includeEdit: true,
        includeDetails: false
      })

      dispatch(CLIENTS)

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível criar a conta'))
    }
  },

  [ACCOUNT_VINDI]: async ({ dispatch, commit }, payload) => {
    try {
      const response = await axios.get(`company/${payload}/vindi`)

      commit(ACCOUNT_VINDI, response)

      return response
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('ID não encontrado'))

      return e
    }
  },

  [ACCOUNT_DELETE]: async ({ commit }, id) => {
    const response = await axios.delete('/company/' + id)
    return response
  },

  [ACCOUNT_CLEAR]: async ({ commit }) => {
    commit(ACCOUNT, {})

    commit(ACCOUNT_VINDI, {})
  },

  [ACCOUNT_CONFIG_UPDATE]: async ({ commit, state, dispatch }, { payload, accountId }) => {
    try {
      const data = toDeepFormData(payload)
      const { data: success } = await axios.post(`/company/${accountId}/implantation`, data)

      const notification = {
        type: success ? 'success' : 'error',
        message: success
          ? 'Configurações alteradas com sucesso!'
          : 'Não foi possível alterar as configurações.'
      }

      dispatch(NOTIFICATIONS_INCLUDE, notification)

      return success
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível alterar as configurações.'))

      return false
    }
  },
  [CREATE_WALLET_EXIT_ORDER]: async ({ commit, state, dispatch }, payload) => {
    try {
      const { data: success } = await axios.post(`company/${payload.client_id}/withdraw`, payload)

      const notification = {
        type: success ? 'success' : 'error',
        message: success
          ? 'Saldo adicionado com sucesso!'
          : 'Não foi possível concluir a solicitação.'
      }

      dispatch(NOTIFICATIONS_INCLUDE, notification)

      return success
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível concluir a solicitação.'))

      return false
    }
  },
  [CREATE_WALLET_ORDER]: async ({ commit, state, dispatch }, payload) => {
    try {
      const { data: success } = await axios.post('company/statement', payload)

      const notification = {
        type: success ? 'success' : 'error',
        message: success
          ? 'Saldo adicionado com sucesso!'
          : 'Não foi possível concluir a solicitação.'
      }

      dispatch(NOTIFICATIONS_INCLUDE, notification)

      return success
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível concluir a solicitação.'))

      return false
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/account.js